import { useMutation, useQueryClient } from 'react-query';
import { useTranslation } from 'react-i18next';
import showSnackbar, { showErrorSnackbar } from 'components/shared/Snackbar';
import { submitBatchTaskAction } from 'RestAPIs/planner-messages';
import { MessageActionType } from '../types';
import { usePlannerMessagesStore } from '../store';

const useSubmitBatchAction = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('common');
  const clearSelection = usePlannerMessagesStore(
    (state) => state.clearSelection
  );

  const { mutateAsync, isLoading } = useMutation(
    (variables: {
      taskIds: string[];
      actionType: MessageActionType;
      note?: string;
    }) => submitBatchTaskAction(variables),
    {
      onSuccess: (response) => {
        const { success, failed } = response.data;

        if (success > 0 && failed === 0) {
          showSnackbar({
            severity: 'success',
            message: t('plannerMessages.bulkActionSuccess')
          });
        } else if (success > 0 && failed > 0) {
          showSnackbar({
            severity: 'warning',
            message: t('plannerMessages.bulkActionPartlyFailed', { failed })
          });
        } else if (success === 0 && failed > 0) {
          showSnackbar({
            severity: 'warning',
            message: t('plannerMessages.bulkActionAllFailed', { failed })
          });
        }

        clearSelection();
        queryClient.invalidateQueries('plannerTasks');
        queryClient.invalidateQueries('plannerTaskTabCounts');
      },
      onError: () => showErrorSnackbar()
    }
  );

  return { mutateAsync, isLoading };
};

export default useSubmitBatchAction;
